export default "/static/build/mastercard.png";